import { withInstall } from '@code-monkey-ui/utils'
import Teleport from './src/teleport.vue'

export const ElTeleport = withInstall(Teleport)

export default ElTeleport

export * from './src/teleport'
